/*
 * we use a dummy program until the real one is generated..
 */
export const dummyProgram = { uniformData: { id: -1 } };
